import React, { useEffect, useState } from 'react';
import RadioGroupField from 'components/RadioGroupField';
import useOperationStepValues from 'router/data/useOperationStepValues';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import PlusIcon from 'icons/Plus.icon';
import MinusIcon from 'icons/Minus.icon';
import { Field, useForm, useFormState } from 'react-final-form';
import InputField from 'components/InputField';
import validations from 'validations';

import './BusinessLocationField.styles.scss';
import './BusinessLocationField.styles.responsive.scss';

const BusinessLocationField: React.FC = () => {
  const { locationOptions } = useOperationStepValues();
  const { t } = useTranslation();
  const { change } = useForm();
  const {
    values: { internationalCountry, businessLocation },
  } = useFormState();

  const [isOther, setIsOther] = useState(!!internationalCountry);

  useEffect(() => {
    if (internationalCountry) {
      change('businessLocation', undefined);
    }
  }, [change, internationalCountry]);

  useEffect(() => {
    if (businessLocation) {
      setIsOther(false);
      change('internationalCountry', undefined);
    }
  }, [businessLocation, change]);

  return (
    <div className="business-location-field">
      <RadioGroupField
        name="businessLocation"
        options={locationOptions}
        styled
        noValidate={!!internationalCountry}
      />
      <Button
        variant="link"
        className="business-location-field__other-button"
        onClick={() => setIsOther((prev) => !prev)}
      >
        {isOther ? <MinusIcon /> : <PlusIcon />}
        {t('businessLocationOtherButton')}
      </Button>
      {isOther && (
        <Field
          name="internationalCountry"
          label={t('internationalCountryLabel')}
          component={InputField}
          validate={validations.required()}
          required
        />
      )}
    </div>
  );
};

export default BusinessLocationField;
